// extracted by mini-css-extract-plugin
module.exports = {"changeCity":"App_changeCity_b9zJh"};